// taken from https://gist.github.com/thgh/7f63a2253c2ad3d6972a196b919b2481
// and inspired by github copilot
export function lighten(color = '#004488', opacity = 1) {
  // Convert to color channels
  const num = parseInt(color.slice(1), 16);
  /* eslint-disable no-bitwise */
  let R = num >> 16;
  let G = (num >> 8) & 0x00ff;
  let B = num & 0x0000ff;
  /* eslint-enable no-bitwise */

  // Interpolate channel
  opacity = Math.min(Math.max(opacity, 0), 1);
  R = Math.round(R + (1 - opacity) * (255 - R));
  G = Math.round(G + (1 - opacity) * (255 - G));
  B = Math.round(B + (1 - opacity) * (255 - B));

  // Encode as hex
  return (
    '#' +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
}

/**
 * Hash function used to generate an arbitrary number from a given string
 *
 * @param input {string} - Input string used to generate the hash
 * @returns {number} - A unique hash value
 */
const hashString = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    /* eslint-disable no-bitwise */
    // apply some randomization to the hash
    hash = (hash << 5) - hash + char;
    // ensure the hash is a 32-bit integer
    hash |= 0;
    /* eslint-enable no-bitwise */
  }
  return hash;
};

/**
 * Generates an HSL color using a given input string
 *
 * @param seed {string} - An input string used to generate a hash which is then converted
 * to an HSL color
 * @returns {string} - An HSL color in the format hsl(hue, saturation%, lightness%)
 */
export const generateHSLColor = (seed: string): string => {
  // ensure hash is positive to avoid a negative modulo operation
  const hash = Math.abs(hashString(seed));
  // generate an HSL color based on the hash
  const hue = hash % 360; // Hue: 0-360
  const saturation = 50 + (hash % 31); // Saturation: 50-80
  const lightness = 30 + (hash % 21); // Lightness: 30-50
  // return the HSL color as a string
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
